// The ordinal minted from a post, from whichever media field holds it.
export function mintedOrdinalId(answer: any): string | null {
    const files = Array.isArray(answer?.file_urls) ? answer.file_urls : []
    const id =
        answer?.image_bsv_ordinal?.id ||
        answer?.video_bsv_ordinal?.id ||
        files.find((file: any) => file?.bsv_ordinal?.id)?.bsv_ordinal?.id
    return id ? String(id) : null
}
